/**
 * Morning Brief Service
 *
 * Calls POST /api/brief/morning on func-axn-analyst-api. The brief combines
 * structured queue/tenant data with an LLM-authored narrative paragraph.
 */

import type { MorningBrief } from '../data/types';
import { apiPost, type ApiResponse } from './api';

export async function getMorningBrief(): Promise<ApiResponse<MorningBrief>> {
  return apiPost<MorningBrief>('/brief/morning', {});
}
